<script setup lang="ts">
import {onMounted} from 'vue';
import CurrentUser from '@/views/header/CurrentUser.vue';
import CabLink from '@/views/header/CabLink.vue';
import ZZC from '@/views/header/ZZCLogo.vue';
import VersionComponent from '@/views/header/VersionComponent.vue';
import {reload} from '@/base/loadingState.js';

onMounted(async () => {
    await reload();
});
</script>

<template>
  <div class="h-screen relative">
    <VersionComponent/>

    <div class="flex flex-row backdrop-brightness-90 justify-between">
      <ZZC/>

      <div class="flex flex-row items-end space-x-4">
        <CabLink name="Thema's" to="/admin/thema"/>
        <CabLink name="Instellingen" to="/admin/organization"/>
        <CabLink name="Gebruikers" to="/admin/user"/>
        <CabLink name="Mijlpalen" to="/admin/milestone" icon="m"/>
        <CabLink name="KPI's" to="/admin/kpi" icon="k"/>
        <CabLink name="Rapporten" to="/admin/status"/>
        <CabLink name="AltView" to="/admin/altview"/>
        <CabLink name="Vecozo" to="/admin/vecozo"/>
        <CabLink name="Beheer" to="/admin/admin"/>
      </div>

      <CurrentUser/>
    </div>

    <router-view/>
  </div>
</template>
